
import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import { ProGPTChatSession } from '../../../../domain/chat/models/ChatSession';
import { ProGPTChatSessionDto } from '../dtos/responses/ProGPTChatSessionDto';
import { defaultProGPTAgent } from './mapProGPTAgentToMetadata';


const toTimestamp = (value?: string | number): number | undefined => {
    if (value === undefined || value === null) {
        return undefined;
    }

    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? undefined : timestamp;
};

export const mapProGPTChatSessionDtoToModel = (dto: ProGPTChatSessionDto): ProGPTChatSession => ({


    id: dto.id,
    userId: dto.userId, // update once userId is added to the dto
    title: dto.title,
    providerType: ChatProviderType.ProGPT,
    agentId: defaultProGPTAgent.agentId,
    createdDate: toTimestamp(dto.createdDate) ?? Date.now(),
    modifiedDate: toTimestamp(dto.modifiedDate) ?? toTimestamp(dto.lastMessageTimeStamp),
    isTitleGenerated: dto.isTitleGenerated,
    persona: dto.persona,
});
